import { importProvidersFrom } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { LoggerModule } from 'ngx-logger';
import { QuillModule } from 'ngx-quill';
import { SharedModule } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ProgressBarModule } from 'primeng/progressbar';
import { RippleModule } from 'primeng/ripple';
import { SplitterModule } from 'primeng/splitter';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { CoreModule } from '../core.module';
import {LOGGER_CONFIG} from 'src/app/shared/configuration/loggerConfig';
import {CommonBaseModule} from 'src/app/tinea-components/okta/common-base.module';
import {MaterialModule} from 'src/app/shared/material.module';

export const provideAppLegacyModules = () => [
  importProvidersFrom(
    LoggerModule.forRoot(LOGGER_CONFIG),
    FormsModule,
    ReactiveFormsModule,
    GoogleMapsModule,
    SharedModule,
    CoreModule,
    QuillModule.forRoot(),
    TableModule,
    TooltipModule,
    ToastModule,
    ButtonModule,
    RippleModule,
    ProgressBarModule,
    MatSnackBarModule,
    MatFormFieldModule,
    MatInputModule,
    MatSidenavModule,
    CommonBaseModule,
    MaterialModule,
    SplitterModule,
  ),
];
